import { ArrowLeft } from 'lucide-react';
import { type To, useNavigate } from 'react-router';

export type BackButtonProps = {
	to?: To;
	onClickBackButton?: () => void;
};

const BackButton = ({ to, onClickBackButton }: BackButtonProps) => {
	const navigate = useNavigate();

	const handleBackButtonClick = () => {
		onClickBackButton?.();

		if (to) {
			navigate(to);
		} else {
			navigate(-1);
		}
	};

	return (
		<button
			type="button"
			onClick={handleBackButtonClick}
			className="shrink-0 cursor-pointer"
			aria-label="뒤로가기"
		>
			<ArrowLeft size={24} className="text-mantang-black" />
		</button>
	);
};

export default BackButton;
